import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HistoryService } from "./history.service";
import { Router } from "@angular/router";
var HistoryComponent = (function () {
    function HistoryComponent(historyService, differs, toastr, vcr, router) {
        this.historyService = historyService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    HistoryComponent.prototype.ngOnInit = function () {
        this.title = "History";
        this.filterParams = {
            size: 10,
            page: 0
        };
    };
    HistoryComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getHistoryList();
        }
    };
    HistoryComponent.prototype.getHistoryList = function () {
        var _this = this;
        this.isLoading = true;
        this.historyService.getHistoryList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.historyList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
                _this.isLoading = false;
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    HistoryComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    return HistoryComponent;
}());
export { HistoryComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/history/history.component.ts.pre-build-optimizer.js